import { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import Loading from "../../components/Loading";
import Menu from "../../components/Menu";
import api from "../../services/api";

export function ArtigoPCP() {
    const [artigos, setArtigos] = useState([]);
    const [data, setData] = useState([]);
    const [id, setId] = useState("");
    const [familia, setFamilia] = useState("");
    const [edit, setEdit] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const [filtroArtigo, setFiltroArtigo] = useState("");
    const [filtroFamilia, setFiltroFamilia] = useState("");

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const getData = useCallback(() => {
        setIsLoading(true);
        api.get("cadastros/artigos-pcp").then((response) => {
            setArtigos(response.data.artigos);
            setData(response.data.dados);
            
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
        });
    }, []);

    function handleDelete(rowData) {
        confirmDialog({
            acceptClassName: "p-button-danger",
            acceptLabel: "Excluir",
            rejectClassName: "p-button-secondary",
            rejectLabel: "Cancelar",
            header: "Excluir",
            message: "Você tem certeza que deseja excluir esse registro?",
            accept: () => {
                setIsLoading(true);
                api.delete(`cadastros/artigos-pcp/${rowData.id}/delete`).then((response) => {
                    getData();
                    setIsLoading(false);
                    showSuccess(response);
                }).catch((error) => {
                    setIsLoading(false);
                    showError(error);
                });
            }
        });
    }

    function handleDeactivate(rowData) {
        setIsLoading(true);
        api.get(`cadastros/artigos-pcp/${rowData.id}/deactivate`).then((response) => {
            getData();
            setIsLoading(false);
            showSuccess(response);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }

    function handleSubmit() {
        setIsLoading(true);

        if (edit) {
            api.put(`cadastros/artigos-pcp/${id}/update`, { familia })
                .then((response) => {
                    getData();
                    setIsLoading(false);
                    setIsVisible(false);
                    setEdit(false);
                    setFamilia("");
                    showSuccess(response);
                })
                .catch((error) => {
                    setIsLoading(false);
                    showError(error);
                });
        } else {
            api.post("cadastros/artigos-pcp", {
                artigo_id: id,
                familia,
            })
            .then((response) => {
                getData();
                setIsLoading(false);
                setIsVisible(false);
                setEdit(false);
                setFamilia("");
                showSuccess(response);
            })
            .catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        }
    }

    function onShow() {
        setIsVisible(true);
    }

    function onHide() {
        setIsVisible(false);
        setEdit(false);
        setFamilia("");
    }

    useEffect(() => {
        getData();
    }, [getData]);

    const dadosFiltrados = data.filter((item) => {
        const matchArtigo = item.codigo ? item.codigo.toLowerCase().includes(filtroArtigo.toLowerCase()) : true;
        const matchFamilia = item.familia ? String(item.familia).toLowerCase().includes(filtroFamilia.toLowerCase()) : true;
        return matchArtigo && matchFamilia;
    });

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Dialog
                header={edit ? `Editar o artigo ${id}` : "Cadastrar artigo"}
                onHide={onHide}
                style={{ minWidth: "30vw" }}
                visible={isVisible}
            >
                <div className="p-fluid">
                    <div className="p-field">
                        {!edit && (
                            <>
                                <label htmlFor="">Artigo: </label>
                                <Dropdown
                                    emptyFilterMessage="Nenhum resultado encontrado."
                                    emptyMessage="Nenhum artigo encontrado."
                                    filter
                                    onChange={e => setId(e.value)}
                                    options={artigos}
                                    optionLabel="codigo"
                                    optionValue="id"
                                    value={id}
                                />
                            </>
                        )}

                        <label htmlFor="" className="p-mt-2">Família: </label>
                        <InputText
                            id="familia" 
                            type="number"
                            value={familia} 
                            onChange={(e) => setFamilia(e.target.value)}
                            placeholder="Digite a família"
                        />
                    </div>
                    <div className="p-d-flex p-flex-row">
                        <Button className="p-mr-4 p-button-secondary" label="Cancelar" onClick={onHide} />
                        <Button className="p-ml-4 p-button-success" label={edit ? "Atualizar" : "Salvar"} onClick={handleSubmit} />
                    </div>
                </div>
            </Dialog>

            <Card className="p-m-1" title="Artigos PCP">
                <div className="p-d-flex p-jc-between p-ai-center p-mb-3 p-flex-wrap">
                    <div className="p-d-flex p-ai-center p-gap-2">
                        <InputText
                            placeholder="Filtrar por artigo..."
                            value={filtroArtigo}
                            onChange={(e) => setFiltroArtigo(e.target.value)}
                            className="p-mr-2"
                        />
                        <InputText
                            placeholder="Filtrar por família..."
                            value={filtroFamilia}
                            onChange={(e) => setFiltroFamilia(e.target.value)}
                        />
                    </div>
                    <Button 
                        className="p-m-1"
                        icon="pi pi-plus"
                        onClick={onShow}
                        tooltip="Cadastrar novo"
                    />
                </div>

                <DataTable
                    className="p-m-1"
                    emptyMessage="Nenhum artigo cadastrado ou encontrado."
                    size="small"
                    value={dadosFiltrados}
                    removableSort
                >
                    <Column header="Artigo" field="codigo" sortable />
                    <Column header="Ativo" field="ativof" sortable />
                    <Column header="Família" body={rowData => rowData.familia || '-'} sortable field="familia" />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            {rowData.ativo === true ? (
                                <Button className="p-m-1 p-button-warning" icon="pi pi-ban" onClick={() => handleDeactivate(rowData)} />
                            ): (
                                <Button className="p-m-1 p-button-success" icon="pi pi-check" onClick={() => handleDeactivate(rowData)} />
                            )}
                            <Button className="p-m-1 p-button-danger" icon="pi pi-trash" onClick={() => handleDelete(rowData)} />
                            <Button
                                className="p-m-1 p-button-info"
                                icon="pi pi-pencil"
                                onClick={() => {
                                    setId(rowData.id); 
                                    setFamilia(rowData.familia || '');
                                    setEdit(true);
                                    setIsVisible(true);
                                }}
                            />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    );
}